/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Slug_PlaceholderInputs */

const en_admin_posts_slug_placeholder = /** @type {(inputs: Admin_Posts_Slug_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. my-first-post`)
};

const zh_admin_posts_slug_placeholder = /** @type {(inputs: Admin_Posts_Slug_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 my-first-post`)
};

/**
* | output |
* | --- |
* | "e.g. my-first-post" |
*
* @param {Admin_Posts_Slug_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_slug_placeholder = /** @type {((inputs?: Admin_Posts_Slug_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Slug_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_slug_placeholder(inputs)
	return zh_admin_posts_slug_placeholder(inputs)
});
export { admin_posts_slug_placeholder as "admin.posts.slug_placeholder" }